import { NgModule } from '@angular/core';
import { userRouter } from './user.router';
import { CommonModule } from '@angular/common';
import { UserComponent } from './user.component';
import { UserIsLoggedInGuard } from './guards/user.guard';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { PointsComponent } from './components/points/points.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { SettingComponent } from './components/setting/setting.component';
import { PackagesComponent } from './components/packages/packages.component';
import { MyOrdersComponent } from './components/my-orders/my-orders.component';
import { AddressesComponent } from './components/addresses/addresses.component';
import { FileShareComponent } from './components/file-share/file-share.component';
import { NavigationComponent } from './components/navigation/navigation.component';
import { UserDashboardComponent } from './components/user-dashboard/user-dashboard.component';
import { DownloadOrdersComponent } from './components/download-orders/download-orders.component';
import { ReferralCodeComponent } from './components/referral-code/referral-code.component';
import { PaymentDetailedComponent } from './components/my-orders/payment-detailed/payment-detailed.component';
import { PaymentReviewComponent } from '../components';
import { ClipboardModule } from '@angular/cdk/clipboard';

@NgModule({
  declarations: [
    UserComponent,
    SettingComponent,
    ToolbarComponent,
    MyOrdersComponent,
    FileShareComponent,
    PointsComponent,
    AddressesComponent,
    PackagesComponent,
    UserDashboardComponent,
    NavigationComponent,
    DownloadOrdersComponent,
    ReferralCodeComponent,
    PaymentDetailedComponent,
    PaymentReviewComponent,
  ],

  providers: [
    UserIsLoggedInGuard,
    // { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
  ],

  imports: [userRouter, CommonModule, SharedModule, ClipboardModule],
  exports: [RouterModule, ToolbarComponent],
})
export class UserModule {}
